import { GENERIC_MESSAGES } from 'shared/constants/GenericMessages';
import { COST_CENTRE_MESSAGES } from 'core/centrocosto/constants/CostCentreMessages';
import { ApiError } from 'shared/http';

export class SearchCostCentreTotalsError {
  message: string;

  constructor(err: ApiError) {
    switch (err.status) {
      case 400:
        if (err.message === 'empty_cc') {
          this.message = COST_CENTRE_MESSAGES.costCentreIdIsNull;
        } else {
          this.message = COST_CENTRE_MESSAGES.costCentreNotFound;
        }
        break;
      case 401:
        if (err.message === 'not allowed') {
          this.message = COST_CENTRE_MESSAGES.userNotAllowed;
        } else {
          this.message = GENERIC_MESSAGES.authenticationError;
        }
        break;
      case 403:
        this.message = COST_CENTRE_MESSAGES.notAllowed;
        break;
      default:
        this.message = GENERIC_MESSAGES.genericError;
    }
  }
}
